import APIError from '../APIError';
class Conflict extends APIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 409;
        super(status, ...args);
    }
}
export default Conflict;
